import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.766 3.983c.243.1.464.248.65.434l6.168 6.167a2 2 0 0 1 .587 1.417 2.01 2.01 0 0 1-.587 1.416l-6.168 6.167a2 2 0 0 1-1.416.587 2 2 0 0 1-1.416-.587l-6.168-6.167a2 2 0 0 1-.587-1.416 2 2 0 0 1 .587-1.417l6.168-6.167A2 2 0 0 1 12 3.83c.263 0 .523.052.766.153m-1.473 9.724a.997.997 0 0 0 1.414 0A1 1 0 0 0 13 13V8a.997.997 0 0 0-1-1 .997.997 0 0 0-1 1v5c0 .265.105.52.293.707m0 3a.997.997 0 0 0 1.414 0 .997.997 0 0 0 0-1.414.997.997 0 0 0-1.414 0 .997.997 0 0 0 0 1.414" }, null, -1)
  ]))]))
}
export default { render: render }